import { Icon, Link, LinkProps, TypeIconName } from '@bitrise/bitkit';

interface LinkItemProps extends LinkProps {
  iconName: TypeIconName;
}

const LinkItem = (props: LinkItemProps) => {
  const { children, iconName, isExternal, href, ...rest } = props;
  return (
    <Link
      display="flex"
      alignItems="center"
      gap="12"
      href={href}
      isExternal={isExternal}
      paddingY="12"
      paddingX="24"
      _hover={{ backgroundColor: 'neutral.95' }}
      {...rest}
    >
      <Icon name={iconName} />
      {children}
    </Link>
  );
};

export default LinkItem;
